/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_No_DataInputs */

const vi_dashboard_manager_no_data = /** @type {(inputs: Dashboard_Manager_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu`)
};

/**

* @param {Dashboard_Manager_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_no_data = /** @type {((inputs?: Dashboard_Manager_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_no_data(inputs)
});